<template>
  <div
    class="showActBox"
    @mouseover="hoverIn"
    @mouseleave="hoverOut"
    @click="goToArchitecture"
  >
    <img
      class="showActImg"
      :class="{ imgHover: isHovering }"
      :src="imageUrl"
      alt=""
    />
    <div class="content-box" v-if="!isHovering">
      <div class="exhibitionBox-content-title">
        {{ lan ? showData.titleEn : showData.title }}
      </div>
      <img class="right-arrow" src="@/assets/rightArr_gery.png" alt="" />
      <div class="overlay-mask"></div>
    </div>
    <div class="content-box-hover" v-else>
      <div class="hover-title">
        {{ lan ? showData.titleEn : showData.title }}
      </div>
      <div class="hover-dec">
        {{ lan ? showData.infoEn : showData.info }}
      </div>
      <img class="right-arrow-hover" src="@/assets/rightArr_black.png" alt="" />
      <div class="overlay"></div>
    </div>
  </div>
</template>  
  
<script>
export default {
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showType: {
      type: Number,
      default: 0,
    },
    showIndex: {
      // 新增索引属性
      type: Number,
      default: 0,
    },
    showApi: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isHovering: false, // 控制鼠标是否悬停
      imageUrl: null,
      lan: this.$store.state.isEn,
      isIndex: false,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    if (this.showData && this.showData.imageUrl) {
      this.imageUrl = this.showData.imageUrl;
    }
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    hoverIn() {
      this.isHovering = true; // 鼠标进入时设置为 true
    },
    hoverOut() {
      this.isHovering = false; // 鼠标离开时设置为 false
    },
    goToArchitecture() {
      // 传递类型和索引
      this.$emit("changeData", this.showType, this.showIndex);

      // 如果是移动端，直接触发弹窗显示
      if (this.isIndex) {
        // 移动端直接触发弹窗显示
        this.$emit("showMobileDialog", this.showType, this.showIndex);
      } else {
        // PC端处理
        let columnId = 1;
        let hash = "";
        let index = this.showIndex;

        if (this.showType === 0) {
          hash = "#keySpace";
        } else if (this.showType === 1) {
          hash = "#architecture";
        }

        // 检查当前是否已经在 aboutCY 页面
        if (this.$route.name === "CYTdetail") {
          // 如果已经在目标页面，直接打开弹窗，不滚动页面
          this.$nextTick(() => {
            // 设置弹窗数据并显示
            this.$emit("changeData", this.showType, this.showIndex);
            this.$root.$emit("openDialog", this.showType, this.showIndex);
          });
        } else {
          // 如果不在目标页面，则跳转
          this.$router.push({
            name: "aboutCY",
            query: {
              columnId: columnId,
              index: index, // 添加索引参数
            },
            hash: hash,
          });
        }
      }
    },
  },
};
</script>
  
<style scoped>
.showActBox {
  width: 32%;
  max-height: 330px;
  height: auto;
  margin-top: 30px;
  overflow: hidden; /* 防止内容溢出 */
  position: relative;
  border-radius: 0;
  cursor: pointer;
}
.exhibitionBox-content-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  position: absolute;
  bottom: 33px;
  left: 30px;
  z-index: 10;
  cursor: pointer;
}

.content-box,
.content-box-hover {
  position: absolute; /* 绝对定位以重叠内容 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 20px 20px 20px 25px; /* 或根据需要调整 */
  box-sizing: border-box;
  cursor: pointer;
}

.content-box-hover {
  display: flex;
  cursor: pointer;
}

.hover-title {
  width: 100px;
  text-align: left;
  padding-top: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
  font-weight: Regular;
  cursor: pointer;
  z-index: 10;
}
.hover-dec {
  width: 330px;
  height: 242px;
  padding: 20px 5px 20px 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #585c64;
  text-align: left;
  line-height: 20px;
  font-weight: Regular;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 弹性盒模型 */
  -webkit-box-orient: vertical; /* 元素垂直居中*/
  -webkit-line-clamp: 11; /*  文字显示的行数*/
  cursor: pointer;
  z-index: 10;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%; /* 蒙层高度 */
  background-color: #f2f2f2c4; /* 半透明黑色 */
  cursor: pointer;
  z-index: 1;
}
.overlay-mask {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%; /* 蒙层高度 */
  background-color: rgba(0, 0, 0, 0.16); /* 半透明黑色 */
  cursor: pointer;
}
.showActBox .showActImg {
  width: 100%;
  opacity: 1;
  object-fit: cover;
}
.imgHover {
  opacity: 0.1;
}
.content-box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.right-arrow {
  width: 32px;
  height: 20px;
  position: absolute;
  bottom: 33px;
  right: 30px;
  z-index: 10;
}
.right-arrow-hover {
  width: 32px;
  height: 20px;
  position: absolute;
  bottom: 33px;
  right: 30px;
}
@media (max-width: 1450px) {
  .showActBox {
    width: 31%;
    max-height: 293px;
    height: auto;
    margin: 15px 10px;
    overflow: hidden; /* 防止内容溢出 */
    position: relative;
    border-radius: 0;
    cursor: pointer;
  }
  .showActBox .showActImg {
    width: 100%;
    opacity: 1;
    object-fit: cover;
  }
  .hover-dec {
    width: 100%;
    height: 180px;
    padding: 20px 5px 20px 15px;
    font-family: SourceHanSansCN-Regular;
    font-size: 15px;
    color: #585c64;
    text-align: left;
    line-height: 20px;
    font-weight: Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; /* 弹性盒模型 */
    -webkit-box-orient: vertical; /* 元素垂直居中*/
    -webkit-line-clamp: 8; /*  文字显示的行数*/
    cursor: pointer;
  }
  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%; /* 蒙层高度 */
    cursor: pointer;
    background-color: #f2f2f2c4; /* 半透明黑色 */
  }
  .overlay-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%; /* 蒙层高度 */
    background-color: rgba(0, 0, 0, 0.16); /* 半透明黑色 */
    cursor: pointer;
  }
}
@media (max-width: 960px) {
  .showActBox {
    width: 91.7%;
    height: auto;
    max-height: 633px;
    margin: 20px auto 0;
    overflow: hidden; /* 防止内容溢出 */
    position: relative;
    border-radius: 0;
    cursor: pointer;
  }
  .showActBox .showActImg {
    max-width: 100%;
    opacity: 1;
    object-fit: cover;
  }
  .hover-dec {
    width: 100%;
    max-height: 180px;
    padding: 10px 5px 10px 10px;
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #585c64;
    text-align: left;
    line-height: 18px;
    font-weight: Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; /* 弹性盒模型 */
    -webkit-box-orient: vertical; /* 元素垂直居中*/
    -webkit-line-clamp: 10; /*  文字显示的行数*/
    cursor: pointer;
  }
  .exhibitionBox-content-title {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    position: absolute;
    bottom: 6.5%;
    left: 5.8%;
    z-index: 10;
    cursor: pointer;
  }
  .right-arrow {
    width: 46px;
    height: 30px;
    position: absolute;
    bottom: 6.5%;
    right: 5.8%;
    z-index: 10;
  }
}
@media (max-width: 768px) {
  .showActBox {
    height: auto;
    margin: 5px auto;
    overflow: hidden; /* 防止内容溢出 */
    position: relative;
    border-radius: 0;
    cursor: pointer;
  }
  .exhibitionBox-content-title {
    font-size: 14px;
  }

  .right-arrow {
    width: 27px;
    height: 18px;
  }
  .hover-title {
    font-size: 14px;
    padding: 0px 5px;
  }
  .hover-dec {
    padding: 0px 5px;
    font-size: 12px;
    color: #585c64;
    text-align: left;
  }
}
</style>